export const DemographicBreakdownConstants = {
  STARTERBOX_BODY:
    "Want more demographic groups, synced nightly with your student information system?",
  STARTERBOX_ACTION: "Learn more",
};
